export default {
  rentalSteps: {
    NOT_STARTED: 'Başlamadı',
    PREPARING_VEHICLE: 'Araç Hazırlanıyor',
    FINISHED: 'Tamamlandı',
    CANCELED: 'İptal Edildi',
    WAITING_RENTAL_START: 'Kiralama Başlamayı Bekliyor',
    VEHICLE_ON_DELIVERY: 'Araç Teslim Ediliyor',
    RENTAL_IN_PROGRESS: 'Aktif Yolculuk',
    WAITING_CUSTOMER_TO_VEHICLE: 'Müşteri Araca Bekliyor',
    WAITING_PAYMENT: 'Ödeme Bekleniyor',
    WAITING_RENTAL_END: 'Kiralama Bitmesi Bekleniyor',
  },
  planning: {
    title: 'Planlama',
    noStatusMatch: 'Seçili statüye uyan kiralama yok',
    vehicle: 'Araç',
    zoomIn: 'Yakınlaştır',
    zoomOut: 'Uzaklaştır',
    continuesBefore: 'Önceki günden devam ediyor',
    continuesAfter: 'Sonraki güne devam ediyor',
    outOfService: 'Hizmet Dışı · {reason}',
    outOfServiceUntil: '{until} tarihine kadar Hizmet Dışı · {reason}',
    popup: {
      details: 'Detaylar',
      openDetails: 'Kiralama detayları',
    },
  },
  newRequest: {
    title: 'Yeni flexiCar Talebi',
    summary: '{vehicle} rezerve ediliyor',
    lookupsFailed: 'Formun bazı seçenekleri yüklenemedi. Formu kapatıp tekrar deneyin.',
    pickup: 'Teslim Alma',
    dropoff: 'Teslim Etme',
    driver: 'Sürücü Adı',
    driverPlaceholder: 'Sürücü seçin',
    driverNoResults: 'Eşleşen sürücü yok.',
    driverNoOptions: 'Seçilebilecek sürücü yok.',
    passengers: 'Yolcu Sayısı',
    passengersUpdated: 'Yolcu sayısı eklenen sürücülere göre güncellendi',
    destination: 'Varış Noktası',
    destinationPlaceholder: 'Yer arayın',
    destinationFailed: 'Bu yer bulunamadı. Başka bir yer arayın.',
    reason: 'Kiralama Nedeni',
    reasonPlaceholder: 'Neden seçin',
    reasonTextPlaceholder: 'Neden girin',
    explanation: 'Açıklama',
    explanationPlaceholder: 'Kiralama nedenini açıklayın',
    costCenter: 'Masraf Merkezi',
    costCenterPlaceholder: 'Masraf merkezi seçin',
    rentalType: 'Kiralama Tipi',
    rentalTypeHint: 'Kiralama tipini görmek için sürücü ve saatleri seçin.',
    additional: {
      add: '+ Ek Sürücü',
      rowLabel: '{n}. Ek Sürücü Telefon Numarası',
      phonePlaceholder: 'Telefon numarası',
      addButton: 'SÜRÜCÜ EKLE',
      cancel: 'VAZGEÇ',
      remove: 'Sürücüyü kaldır',
      notFound: {
        title: 'Eşleşen Sürücü Yok',
        message: 'Bu telefon numarasıyla kullanıcı bulunamadı.',
        check: 'Numarayı kontrol et',
        cancel: 'Sürücü eklemekten vazgeç',
      },
      duplicate: {
        title: 'Sürücü Zaten Eklendi',
        message: 'Bu numarayla bir sürücü zaten eklediniz.',
        close: 'Kapat',
      },
    },
    cancel: 'Vazgeç',
    reserve: 'Rezerve Et',
    validation: {
      required: 'Bu alan zorunludur.',
      pickupTooEarly: 'Teslim alma en erken {time} olabilir.',
      dropoffBeforePickup: 'Teslim etme, teslim almadan sonra olmalı.',
      passengersMax: 'En fazla {max} yolcu.',
    },
    created: '{driver} için rezervasyon oluşturuldu.',
    errors: {
      leadTime: 'Teslim alma en az {minutes} dakika sonra olmalı.',
      overlap: 'Sürücünün bu saatlerde başka bir rezervasyonu var.',
      vehicleUnavailable: 'Bu araç bu saatler için rezerve edilemiyor. Başka bir saat ya da araç deneyin.',
      notAllowed: 'Bu sürücü için ya da bu aracın otoparkında rezervasyon yapamazsınız.',
      noOrganization: 'Bu sürücü bir şirket organizasyonunda değil.',
      costCenter: 'Bu masraf merkezi artık kullanılamıyor. Başka birini seçin.',
      generic: 'Rezervasyon oluşturulamadı.',
    },
  },
  rentals: {
    title: 'Kiralamalar',
    refresh: 'Yenile',
    lastUpdated: 'Son güncelleme',
    vehicleFilter: 'Araç',
    removeFilter: 'Filtreyi kaldır',
    noRentals: 'Seçili tarihlerde kiralama yok',
    loadFailed: 'Kiralamalar yüklenemedi.',
    noPermission: 'Bu işlem için yetkiniz yok.',
    statusChanged: 'Bu kiralamanın durumu siz işlem yaparken değişti (şu an: {status}).',
    statuses: {
      REQUESTED: 'Talep Edildi',
      RESERVED: 'Rezerve',
      DECLINED: 'Reddedildi',
      CANCELED_BY_RIDER: 'Sürücü Tarafından İptal Edildi',
      CANCELED_BY_ADMIN: 'Admin Tarafından İptal Edildi',
      CANCELED_BY_SYSTEM: 'Sistem Tarafından İptal Edildi',
      ACTIVE: 'Aktif',
      OVERDUE: 'Gecikmede',
      COMPLETED_ON_TIME: 'Zamanında Tamamlandı',
      RETURNED_LATE: 'Geç Teslim Edildi',
      ENDED_BY_ADMIN: 'Admin Tarafından Sonlandırıldı',
    },
    columns: {
      vehicle: 'Araç',
      driver: 'Sürücü',
      additionalDrivers: 'Ek Sürücü(ler)',
      status: 'Statü',
      reason: 'Sebep',
      explanation: 'Açıklama',
      pickupLocation: 'Alış Konumu',
      plannedPickup: 'Planlanan Alış Zamanı',
      actualPickup: 'Gerçekleşen Alış Zamanı',
      dropoffLocation: 'Bırakış Konumu',
      plannedDropoff: 'Planlanan Bırakış Zamanı',
      actualDropoff: 'Gerçekleşen Bırakış Zamanı',
      destination: 'Varış Noktası',
      startingMileage: 'Başlangıç Kilometresi',
      endingMileage: 'Bitiş Kilometresi',
      totalDistance: 'Toplam Mesafe ({unit})',
      totalDuration: 'Gerçekleşen Toplam Süre',
      totalCost: 'Gerçekleşen Toplam Maliyet ({currency})',
      rentalModel: 'Kiralama Modeli',
      drivingNotices: 'Sürüş Uyarıları',
      internalDamage: 'Bildirilen Yeni İç Hasar',
      outerDamage: 'Bildirilen Yeni Dış Hasar',
      reservedBy: 'Rezervasyonu Yapan',
      approver: 'Onaylayan',
      adminNote: 'Admin Notu',
      canceledEndedBy: 'İptal Eden/Sonlandıran',
      costCenter: 'Masraf Merkezi',
      history: 'Kiralama Geçmişi',
      actions: 'Aksiyonlar',
    },
    systemApprover: 'Sistem',
    rentalModels: {
      pool: 'Standart',
      poolCalendarDaily: 'Günlük',
    },
    durationUnits: {
      day: 'g',
      hour: 'sa',
      minute: 'dk',
    },
    actions: {
      approve: 'Onayla',
      delete: 'Sil',
      endRental: 'Kiralamayı Sonlandır',
    },
    dialog: {
      approveTitle: 'Kiralama Talebini Onayla',
      approveMessage: '{driver} tarafından oluşturulan araç kiralama talebini onaylamak istiyor musunuz?',
      approve: 'Onayla',
      decline: 'Reddet',
      confirmDecline: 'Reddetmeyi Onayla',
      declineReason: 'Ret sebebi',
      deleteTitle: 'Rezervasyonu Sil',
      deleteMessage: '{driver} için yapılan araç rezervasyonunu silmek istediğinize emin misiniz?',
      delete: 'Sil',
      endTitle: 'Kiralamayı Sonlandır',
      endMessage: '{driver} için devam eden kiralamayı sonlandırmak istediğinize emin misiniz?',
      endRental: 'Kiralamayı Sonlandır',
      reason: 'Sebep',
      cancel: 'Vazgeç',
      approved: 'Kiralama talebi onaylandı.',
      declined: 'Kiralama talebi reddedildi.',
      deleted: 'Rezervasyon silindi.',
      ended: 'Kiralama sonlandırıldı.',
      failed: 'İşlem tamamlanamadı.',
    },
    changeVehicle: {
      title: 'Aracı Değiştir',
      message: 'Bu kiralamanın aracını {from} yerine {to} olarak değiştirmek istediğinize emin misiniz?',
      change: 'Değiştir',
      noVehicles: 'Uygun araç yok',
      loadFailed: 'Uygun araçlar yüklenemedi.',
      changed: 'Araç değiştirildi.',
      rentalNotFound: 'Kiralama bulunamadı.',
      vehicleUnavailable: 'Bu araç artık bu kiralama için uygun değil. Lütfen başka bir araç seçin.',
    },
    details: {
      title: 'Kiralama Detayları',
      tabs: {
        history: 'Geçmiş',
        map: 'Harita',
        notices: 'Sürüş Uyarıları',
        damages: 'Bildirilen Yeni Hasarlar',
        parking: 'Park Bilgisi',
      },
      loadFailed: 'Kiralama detayları yüklenemedi.',
      noDrivingNotices: 'Sürüş uyarısı yok',
      noticeTypes: {
        HARSH_BRAKE: 'Sert Fren',
        SPEED_LIMIT_EXCEEDED: 'Hız Sınırı Aşımı',
        HARSH_ACCELERATION: 'Sert Hızlanma',
        HARSH_CORNERING: 'Sert Dönüş',
      },
      map: {
        noData: 'Bu kiralama için konum verisi yok',
        loadFailed: 'Rota yüklenemedi.',
        stop: '{number}. durak',
      },
      damages: {
        internalTitle: 'Bildirilen Yeni İç Hasar',
        outerTitle: 'Bildirilen Yeni Dış Hasar',
        viewAll: 'Tümünü Gör ({count})',
        atPickup: 'Alışta ({count})',
        atDropoff: 'Bırakışta ({count})',
        loadFailed: 'Hasarlar yüklenemedi.',
      },
      parking: {
        front: 'Ön Görünüm',
        back: 'Arka Görünüm',
        left: 'Sol Görünüm',
        right: 'Sağ Görünüm',
        photoCaption: 'Park Edilmiş Araç Fotoğrafı',
        notAvailable: 'Henüz yok',
        noPhotos: 'Park fotoğrafı yok',
      },
      links: {
        viewDamages: 'Hasarları Gör',
        viewParkingInfo: 'Park Bilgisini Gör',
      },
    },
    history: {
      vehicle: 'Araç',
      driver: 'Sürücü',
      rentalModel: 'Kiralama Modeli',
      status: 'Statü',
      adminNote: 'Admin Notu',
      plannedActualPickup: 'Planlanan / Gerçekleşen Alış',
      plannedActualDropoff: 'Planlanan / Gerçekleşen Bırakış',
      distanceTime: 'Toplam Mesafe / Süre',
      totalCost: 'Toplam Maliyet',
      hideSummary: 'Özeti Gizle',
      showSummary: 'Özeti Göster',
      approveRequest: 'Talebi Onayla',
      deleteReservation: 'Rezervasyonu Sil',
      endRental: 'Kiralamayı Sonlandır',
      by: '{name}',
      approvedAutomatically: 'Talep otomatik olarak onaylandı.',
      noEvents: 'Henüz olay yok',
      eventsFailed: 'Kiralama olayları yüklenemedi.',
      events: {
        requestReceived: 'Talep alındı',
        approved: 'Onaylandı',
        declined: 'Reddedildi',
        canceledByRider: 'Sürücü tarafından iptal edildi',
        canceledByAdmin: 'Admin tarafından iptal edildi',
        canceledBySystem: 'Sistem tarafından iptal edildi',
        rentalEnded: 'Kiralama bitti',
        internalDamageReported: 'İç hasar bildirildi',
        outerDamageReported: 'Dış hasar bildirildi',
        endedByAdmin: 'Admin tarafından sonlandırıldı',
      },
    },
  },
  tracking: {
    title: 'Takip',
    loadFailed: 'Takip verileri yüklenemedi.',
    tabs: {
      ALL: 'Tümü',
      OVERDUE: 'Gecikmede',
      ACTIVE: 'Aktif',
      AVAILABLE: 'Müsait',
      OUT_OF_SERVICE: 'Hizmet Dışı',
    },
    list: {
      searchPlaceholder: 'Araç ID',
      noVehicles: 'Araç bulunamadı',
      hide: 'Araç listesini gizle',
      show: 'Araç listesini göster',
    },
    card: {
      status: 'Statü',
      drivers: 'Sürücü(ler)',
      next: 'Sıradaki: {time}',
      last: 'Son: {status} {time}',
      lastStatus: {
        COMPLETED_ON_TIME: 'Tamamlandı',
        RETURNED_LATE: 'Geç Teslim Edildi',
        ENDED_BY_ADMIN: 'Admin Tarafından Sonlandırıldı',
      },
      noRentalsToday: 'Bugün kiralama yok',
      noRentalsOnDate: 'Bu tarihte kiralama yok',
      oneRental: '1 kiralama',
      rentals: '{count} kiralama',
      outOfService: 'Hizmet Dışı',
      outOfServiceUntil: '{until} tarihine kadar Hizmet Dışı',
      noTelematics: 'Telematik verisi yok',
    },
    map: {
      currentStatusNote: "Pin'ler aracın şu anki durumunu gösterir",
    },
    popup: {
      serviceStatus: 'Hizmet Durumu',
      operationalStatus: 'Operasyonel Durum',
      vehicleState: 'Araç Durumu',
      nextReservationIn: 'Sıradaki Rezervasyona',
      fuel: 'Yakıt',
      lastUpdate: 'Son güncelleme',
      inService: 'Hizmette',
      outOfService: 'Hizmet Dışı',
      outOfServiceUntil: '{until} tarihine kadar Hizmet Dışı',
      plannedOutOfService: '{start} – {until} arası Hizmet Dışı',
      rented: 'Kirada',
      available: 'Müsait',
      ignitionOn: 'Kontak açık',
      ignitionOff: 'Kontak kapalı',
      withRequested: '{duration} (Talep Edildi)',
      fuelValue: '{volume} {unit} ({percent})',
      units: {
        gallon: 'gal',
        litre: 'L',
      },
      viewVehicleDetail: 'Araç Detayını Görüntüle',
      close: 'Kapat',
    },
    kpis: {
      totalRentals: 'Toplam Kiralama',
      pendingRequests: 'Bekleyen Talepler',
      completedOnTime: 'Zamanında Tamamlanan',
      returnedLate: 'Geç Teslim Edilen',
    },
    grid: {
      noRentals: 'Bu tarihte kiralama yok',
      noMatches: 'Seçili filtrelere uyan kiralama yok',
    },
    columns: {
      requestTime: 'Talep Zamanı',
      endedBy: 'Sonlandıran',
      endNote: 'Sonlandırma Notu',
      adminNote: 'Admin Notu',
    },
  },
  vehicles: {
    title: 'Araçlar',
    searchPlaceholder: 'Plaka, araç adı veya şasi numarası ile arayın',
    loadFailed: 'Araçlar yüklenemedi.',
    columns: {
      licensePlate: 'Plaka',
      withUnit: '{label} ({unit})',
      deviceStatus: 'Cihaz Durumu',
      lastLocationUpdate: 'Son Konum Güncellemesi',
      lastAddress: 'Son Adres',
      lastUsageStart: 'Son Kullanım Başlangıcı',
      lastUsageEnd: 'Son Kullanım Bitişi',
      registrationDate: 'Kayıt Tarihi',
    },
    deviceStatus: {
      CONNECTED: 'Bağlı',
      DISCONNECTED: 'Bağlı değil',
      NEVER_CONNECTED: 'Hiç bağlanmadı',
    },
  },
  vehicleDetail: {
    loadFailed: 'Araç bilgileri yüklenemedi.',
    notFound: 'Araç bulunamadı. Silinmiş olabilir.',
    tabs: {
      basicInfo: 'Temel Bilgiler',
      lastLocation: 'Son Konum',
      damageReports: 'Hasar Kayıtları',
    },
    fields: {
      vehiclePlate: 'Plaka',
      vehicleName: 'Araç Adı',
      serviceStatus: 'Hizmet Durumu',
      outOfServiceStart: 'Başlangıç',
      outOfServiceUntil: 'Bitiş',
      outOfServiceReason: 'Sebep',
      modules: 'Modüller',
      sharedFleet: 'Shared Fleet',
      operationalStatus: 'Operasyonel Durum',
      sharedFleetUsage: 'Shared Fleet Kullanımı',
      odometer: 'Odometre',
      fuelLevel: 'Yakıt Seviyesi',
      batteryVoltage: 'Akü Voltajı',
      phoneNumber: 'Telefon Numarası',
      deviceType: 'Cihaz Tipi',
      deviceImei: 'Cihaz IMEI',
      gsmAccountProvider: 'GSM Operatörü',
      gsmAccountNumber: 'GSM Hat Numarası',
      parkingLot: 'Otopark',
      wheelchairEnabled: 'Tekerlekli Sandalyeye Uygun',
      transmissionType: 'Vites Tipi',
      category: 'Kategori',
      make: 'Marka',
      model: 'Model',
      color: 'Renk',
      year: 'Yıl',
      chassisNumber: 'Şasi Numarası',
      capacity: 'Kapasite',
      bikeCapacity: 'Bisiklet Kapasitesi',
      wheelchairCapacity: 'Tekerlekli Sandalye Kapasitesi',
      avgEmissionsPerMile: 'Mil Başına Ort. Emisyon',
      avgEmissionsPerKm: 'Km Başına Ort. Emisyon',
    },
    values: {
      inService: 'Hizmette',
      outOfService: 'Hizmet Dışı',
      outOfServiceLine: 'Hizmet Dışı, {start} – {until}, {reason}, {admin}',
      rented: 'Kirada',
      available: 'Müsait',
      yes: 'Evet',
      no: 'Hayır',
      automatic: 'Otomatik',
      manual: 'Manuel',
      viewRentals: 'Kiralamaları Gör',
    },
    lastLocation: {
      noLocation: 'Telematik verisi yok',
    },
    damages: {
      outer: 'Dış ({count})',
      internal: 'İç ({count})',
      reportedOn: '{date} tarihinde bildirildi',
      reportedAtPickup: '{date} tarihinde alışta bildirildi',
      reportedAtDropoff: '{date} tarihinde bırakışta bildirildi',
      by: '{name}',
      viewRental: 'Kiralamayı Gör',
      viewMore: 'Devamını gör',
      viewLess: 'Daha az göster',
      fixedOn: '{date} tarihinde {name} tarafından onarıldı',
      markFixed: 'Onarıldı Olarak İşaretle',
      undo: 'Geri Al',
      fixTitle: 'Hasar Onarıldı',
      fixMessage: 'Bildirilen hasarı onarıldı olarak işaretlemek istediğinizi onaylayın.',
      undoTitle: 'Onarılmadı Olarak İşaretle',
      undoMessage:
        'Bu hasarı onarılmadı olarak işaretlemek istediğinizi onaylayın. Hasar bu araçta yeniden aktif hasar ' +
        'olarak sayılacak.',
      confirm: 'Onayla',
      fixFailed: 'Hasar güncellenemedi. Lütfen tekrar deneyin.',
      errors: {
        vehicleNotFound: 'Araç bulunamadı.',
        damageNotFound: 'Bu hasar bu araçta bulunamadı.',
      },
      rentalNotFound: 'Kiralama açılamadı.',
      previousPhoto: 'Önceki fotoğraf',
      nextPhoto: 'Sonraki fotoğraf',
      photoTitle: {
        outer: 'Dış hasar',
        internal: 'İç hasar',
      },
    },
    doors: {
      lock: 'Kapıları Kilitle',
      unlock: 'Kapıların Kilidini Aç',
      lockMessage: 'Bu işlem kapıları kilitleyecek. Devam etmek istediğinize emin misiniz?',
      unlockMessage: 'Bu işlem kapıların kilidini açacak. Devam etmek istediğinize emin misiniz?',
      continue: 'Devam',
      rentedTitle: 'Araç şu anda kirada.',
      rentedMessage: 'Kapı komutu göndermeden önce kiralamayı sonlandırmanız gerekiyor.',
      lockSent: 'Kilitleme komutu araca gönderildi.',
      unlockSent: 'Kilit açma komutu araca gönderildi.',
      lockFailed: 'Kapılar kilitlenemedi. Lütfen tekrar deneyin.',
      unlockFailed: 'Kapılar açılamadı. Lütfen tekrar deneyin.',
      errors: {
        noDevice: 'Bu araçta uzaktan kapı cihazı yok.',
        lockNotSent: 'Kilitleme komutu araca gönderilemedi.',
        unlockNotSent: 'Kilit açma komutu araca gönderilemedi.',
      },
    },
    deviceTypes: {
      NONE: 'Yok',
      BASIC_TELEMATIC: 'Temel Telematik',
      REMOTE_DOOR: 'Uzaktan Kapı',
    },
    form: {
      editTitle: 'Aracı Düzenle',
      version: 'Versiyon',
      saved: 'Araç kaydedildi.',
      saveFailed: 'Araç kaydedilemedi. Lütfen tekrar deneyin.',
      plateExists: 'Bu plakayla kayıtlı bir araç zaten var.',
      checkFields: 'Bazı değerler kabul edilmedi. Lütfen alanları kontrol edip tekrar deneyin.',
      refreshRetry: 'Araç, otopark ya da model artık kullanılamıyor. Lütfen sayfayı yenileyip tekrar deneyin.',
      capacityMin: 'Kapasite en az 2 olmalıdır.',
      wheelchairCapacityRequired:
        "Tekerlekli sandalyeye uygun araçta Tekerlekli Sandalye Kapasitesi 0'dan büyük olmalıdır.",
      wheelchairCapacityZero: 'Tekerlekli sandalyeye uygun olmayan araçta Tekerlekli Sandalye Kapasitesi 0 olmalıdır.',
      noCatalog: 'Bu marka, model, yıl ve vites tipine uyan bir araç modeli bulunamadı.',
      parkingLotLocked:
        'Aracın gelecek rezervasyonları var. Otoparkı değiştirmek için önce bu rezervasyonları başka araçlara aktarın.',
      parkingLotChecking: 'Aracın gelecek rezervasyonları kontrol ediliyor...',
      parkingLotUnchecked: 'Aracın gelecek rezervasyonları kontrol edilemediği için otopark şu anda değiştirilemiyor.',
      parkingLotRetry: 'Tekrar dene',
      lookupsFailed: 'Form seçenekleri yüklenemedi. Lütfen tekrar deneyin.',
      startInPast: 'Başlangıç geçmiş bir zaman olamaz.',
      untilAfterStart: 'Bitiş, başlangıçtan sonra olmalıdır.',
      noCategories: 'Tanımlı kategori yok',
      moduleRequired: 'En az bir modül seçin.',
      plateDeleted: 'Bu plaka silinmiş bir araca ait olduğu için kullanılamaz.',
      serviceStatusFixed:
        'Yeni araç Hizmet Dışı olarak eklenir. Araç durumunu değiştirme yetkisi olan bir admin aracı hizmete alabilir.',
      // New Vehicle's save: the vehicle is added, then found in the list and put in service when In Service was chosen
      created: 'Araç eklendi.',
      createdNotInService: 'Araç eklendi ancak hizmete alınamadı. Hizmet Dışı olarak kaldı.',
      createdNotFound: 'Araç eklendi ancak henüz araç listesinde görünmüyor. Görmek için sayfayı yenileyin.',
      createdNotFoundNotInService:
        'Araç eklendi ancak henüz araç listesinde görünmediği için hizmete alınamadı; Hizmet Dışı olarak kaldı. ' +
        'Görmek için sayfayı yenileyin.',
      units: {
        lb: 'lb',
        g: 'g',
      },
      outOfServiceReasons: {
        MAINTENANCE: 'Bakım',
        REPAIR_DAMAGE: 'Onarım / Hasar',
        ACCIDENT: 'Kaza',
        CLEANING: 'Temizlik',
        INSPECTION: 'Muayene',
        STOLEN: 'Çalıntı',
        OTHER: 'Diğer',
      },
    },
    // the warnings before a save that affects the vehicle's rentals; '|' separates one reservation from several
    saveWarning: {
      endRental: {
        title: 'Mevcut Kiralama Sonlandırılsın mı?',
        message:
          'Bu araç şu anda {dropoff} tarihine kadar {driver} tarafından kiralanmış durumda. Aracı Hizmet Dışı ' +
          'yapmak için kiralama şimdi sonlandırılacak ve sürücüye bildirim gönderilecek.',
        confirm: 'Kiralamayı Sonlandır ve Kaydet',
      },
      reservations: {
        title: 'Bu Dönemde Rezervasyonlar Var',
        message:
          'Aracın {start} ile {until} arasında 1 rezervasyonu var. Aracı Hizmet Dışı yapmak için bu rezervasyon ' +
          'iptal edilecek ve sürücüye bildirim gönderilecek. Rezervasyonu korumak için geri dönüp önce başka bir ' +
          'araca aktarın. | Aracın {start} ile {until} arasında {count} rezervasyonu var. Aracı Hizmet Dışı yapmak ' +
          'için bu rezervasyonlar iptal edilecek ve sürücülere bildirim gönderilecek. Rezervasyonları korumak için ' +
          'geri dönüp önce başka araçlara aktarın.',
        messageWithRental:
          'Bu araç şu anda {dropoff} tarihine kadar {driver} tarafından kiralanmış durumda ve {start} ile {until} ' +
          'arasında 1 rezervasyonu var. Aracı Hizmet Dışı yapmak için mevcut kiralama sonlandırılacak ve ' +
          'rezervasyon iptal edilecek. Sürücülere bildirim gönderilecek. Rezervasyonu korumak için geri dönüp önce ' +
          'başka bir araca aktarın. | Bu araç şu anda {dropoff} tarihine kadar {driver} tarafından kiralanmış ' +
          'durumda ve {start} ile {until} arasında {count} rezervasyonu var. Aracı Hizmet Dışı yapmak için mevcut ' +
          'kiralama sonlandırılacak ve rezervasyonlar iptal edilecek. Sürücülere bildirim gönderilecek. ' +
          'Rezervasyonları korumak için geri dönüp önce başka araçlara aktarın.',
        confirm: '1 Rezervasyonu İptal Et ve Kaydet | {count} Rezervasyonu İptal Et ve Kaydet',
        confirmWithRental:
          'Kiralamayı Sonlandır, 1 Rezervasyonu İptal Et ve Kaydet | Kiralamayı Sonlandır, {count} Rezervasyonu ' +
          'İptal Et ve Kaydet',
      },
      removeSharedFleet: {
        title: "Araç Shared Fleet'ten Çıkarılsın mı?",
        message:
          "Aracın ileri tarihli 1 Shared Fleet rezervasyonu var. Aracı Shared Fleet'ten çıkarmak bu rezervasyonu " +
          'iptal edecek ve sürücüye bildirim gönderecek. Rezervasyonu korumak için geri dönüp önce başka bir araca ' +
          'aktarın. Devam eden bir kiralama varsa bitene kadar sürer. | Aracın ileri tarihli {count} Shared Fleet ' +
          "rezervasyonu var. Aracı Shared Fleet'ten çıkarmak bu rezervasyonların tümünü iptal edecek ve " +
          'sürücülere bildirim gönderecek. Rezervasyonları korumak için geri dönüp önce başka araçlara aktarın. ' +
          'Devam eden bir kiralama varsa bitene kadar sürer.',
        confirm: '1 Rezervasyonu İptal Et ve Kaydet | {count} Rezervasyonu İptal Et ve Kaydet',
      },
      goBack: 'Geri Dön',
      checkFailed:
        'Aracın kiralamaları kontrol edilemediği için değişiklikler şu anda kaydedilemiyor. Lütfen tekrar deneyin.',
    },
  },
};
